export default __webpack_public_path__ + "static/media/image-7.7b1da2d4.webp";